import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorsLabelComponent } from './errors-label.component';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
  declarations: [ErrorsLabelComponent],
  imports: [CommonModule, MaterialModule],
  exports: [ErrorsLabelComponent],
})
export class ErrorsLabelModule {}
